import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-se-ngo',
  templateUrl: './se-ngo.component.html',
  styleUrls: ['./se-ngo.component.css']
})
export class SeNgoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
